core.directive('edmToolbarRefundLvl', ['$parse', '$translate',
    function($parse, $translate) {
        var definition = {
            restrict: 'EA',
            replace: true,
            scope: {
                value: '=',
                data: '=',
                disabled: '=',
                prefix: '@',
                label: '@',
                drug: '='
            },
            templateUrl: 'core/application/directive/toolbarRefundLvl/template/edm-toolbar-refund-lvl.html',
            link: function(scope, element, attrs) {
                scope.getLabel = function (v, showNotSet) {
                    if(!v) {
                        if(showNotSet) {
                            return $translate.instant('T.DATA.NOT_SET');
                        } else {
                            return 'X';
                        }
                    }
                    return $parse(scope.label)(v);
                };

                if(scope.disabled) {
                    return false;
                }

                if(!scope.prefix) {
                    scope.prefix = '';
                }
                scope.showList = false;
                var elementOffsetTop = angular.element(element).prop('offsetTop');
                var elementOffsetLeft = angular.element(element).prop('offsetLeft');
                var elementOffsetWidth = angular.element(element).prop('offsetWidth');
                var elementOffsetHeight = angular.element(element).prop('offsetHeight');

                scope.availablePaymentTypes = scope.drug.paymentLevels.map(function(el) {
                    return el.paymentLevel;
                });
                scope.availablePaymentTypes.reverse();

                $(document).on('click', function (e) {
                    if ($(e.target).closest(".toolbar-refund-lvl-content").length === 0) {
                        scope.showList = false;
                        scope.$apply();
                    }
                });

                scope.showItemList = function() {
                    if(scope.showList) {
                        scope.showList = false;
                    } else {
                        scope.showList = true;

                        var listElement = angular.element($('.toolbar-refund-lvl-list'));

                        listElement.css({
                            'position': 'absolute',
                            'top': $(element).offset().top + $(element).outerHeight() + 10 + 'px',
                            'left': $(element).offset().left + 'px'
                        });

                        $('body').append(listElement);
                    }
                };

                scope.selectItem = function(item) {
                    scope.value = item;
                    scope.showList = false;
                };
            }
        };

        return definition;
    }]
);
